import { defineAsyncComponent } from 'vue'
export default {
  blank: defineAsyncComponent(() => import("/usr/src/app/src/layouts/blank.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/usr/src/app/src/layouts/default.vue").then(m => m.default || m)),
  webview: defineAsyncComponent(() => import("/usr/src/app/src/layouts/webview.vue").then(m => m.default || m))
}